import { render } from "./App.vue?vue&type=template&id=b50e5246&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b50e5246&lang=scss"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__